<template>
  <div class="service-intro-block">
    <h4 class="footer-block-title">服務介紹</h4>
    <div class="links-list">
        <router-link class="<laptop:underline spacing" :to="{ name: 'AboutUs' }">首頁</router-link>
        <br class="ipad:hidden"/>
        <a href="https://www.beautinq.com/" target="_blank" rel="noopener noreferrer" class="<laptop:underline spacing">美業歐巴</a>
        <a href="https://www.wisho2o.com/" target="_blank" rel="noopener noreferrer" class="<laptop:underline spacing">生活歐巴</a>
        <a href="https://www.gymomo.com/" target="_blank" rel="noopener noreferrer" class="<laptop:underline spacing">運動歐巴</a>
        <a href="https://www.wishomo.com/" target="_blank" rel="noopener noreferrer" class="<laptop:underline spacing">快消歐巴</a>
        <br class="ipad:hidden"/>
        <router-link class="<laptop:underline spacing" :to="{ name: 'PlanContent' }">方案內容</router-link>
        <router-link class="<laptop:underline spacing" :to="{ name: 'Features', params: { name: 'reservations' } }">功能介紹</router-link>
        <router-link class="<laptop:underline spacing" to="/industrial-application/nail-salon">產業應用</router-link>
        <div></div>
        <div></div>
        <router-link class="<laptop:underline spacing" :to="{ name: 'Blog' }">部落格</router-link>
        <a href="https://linktr.ee/wishmobile_projects" target="_blank" rel="noopener noreferrer" class="<laptop:underline spacing">政府補助</a>
        <a href="https://www.accupass.com/organizer/detail/2302140358578555600450" target="_blank" rel="noopener noreferrer" class="<laptop:underline spacing">講座活動</a>
        <router-link class="<laptop:underline spacing" :to="{ name: 'Columns' }">合作專欄</router-link>
        <div class="laptop:(hidden)"></div>
    </div>
  </div>
</template>
<script setup></script>

<style scoped lang="postcss">
.service-intro-block {
  @apply <laptop: text-left;
}
.footer-block-title {
  @apply text-[32px] text-primary-100 pb-[24px] text-left;
  @apply <laptop:(text-[20px] leading-[28.96px] tracking-[2px] pb-[12px] text-left);
}

.links-list {
  @apply grid grid-rows-5 grid-flow-col gap-x-[24px] gap-y-[3px] text-[20px];
  @apply <laptop: (block text-[16px]);
  & a {
    text-wrap: nowrap;
    @apply leading-[32.76px] tracking-[2px] text-left;
  }
}
.spacing {
  @apply <laptop: mr-[15px];
  @apply <mb: mr-[10px];
}
</style>
